export default __webpack_public_path__ + "static/media/bannerSupport.5882e6f7.webp";